// Prefetch видео в HTTP-кэш браузера, чтобы пользователь не ждал загрузку на следующем блоке.
// Cache-Control на бакете уже настроен (max-age=30 дней, immutable) — браузер сам
// положит ответ в disk-cache и переиспользует его когда <video src=…> попросит тот же URL.
//
// Префетчим ТОЛЬКО видео. Аудио — мелкое, грузится быстро при подходе пользователя к блоку,
// заранее тянуть его не нужно (и подёргивания от лишней предзагрузки никому не нужны).

import type { Block, BlockItem } from "../types";

// Дедупликация в рамках сессии: один URL — один fetch.
// При фейле URL удаляем из множества, чтобы при следующем заходе попытка повторилась.
const prefetched = new Set<string>();

export function prefetchUrls(urls: string[]): void {
  for (const url of urls) {
    if (!url || prefetched.has(url)) continue;
    prefetched.add(url);
    // mode:'cors' — медиа лежит на отдельном origin (MinIO public).
    // credentials:'omit' — не шлём куки, иначе ответ может стать non-cacheable.
    fetch(url, { mode: "cors", credentials: "omit" }).catch(() => {
      prefetched.delete(url);
    });
  }
}

export function collectVideoUrls(blocks: Block[]): string[] {
  const urls: string[] = [];
  for (const block of blocks) {
    for (const item of block.items as BlockItem[]) {
      if (item.type === "video" && item.url) urls.push(item.url);
    }
  }
  return urls;
}
